import { redirect } from "react-router-dom";
import { COMPLAINT_CASE_FORM_POST_API, 
         COMPLAINT_CASE_FORM_POST_BY_HASH_API } from '../../constants/apis';
import { LOGIN_PATH } from '../../constants/paths';
import { postModel } from '../../utils/functions';
import { DEFAULT_ERROR_MESSAGE } from '../../constants/constants';


export async function complaintCaseFormAction({ params, request }) {
    const requestData = await request.json();

    let data;

    if (requestData !== null) {
        if (requestData.resetWarnings) {        
            return {
                message: ""
            };
        }
    
        data = requestData.data;
    }    

    try {
        switch (request.method) {
            case "POST":
                let result = null;

                if (params.complaint_case_id) {
                    result = await postModel(COMPLAINT_CASE_FORM_POST_API.replace('{id}', params.complaint_case_id), data, true);
                }
                else if (params.authHash) {
                    result = await postModel(`${COMPLAINT_CASE_FORM_POST_BY_HASH_API}${params.authHash}`, data, true);
                }             

                return {
                    result,
                    message: ""
                };
            default:
                return {
                    result,
                    message: "Esta página possui erros de implementação/desenvolvimento."
                };
        }
    }
    catch(errors) {
        let message = [];

        if(errors instanceof Array) {
            for(let error of errors) {
                if(error.code === 208) {
                    if(error.message.includes('id might be invalid')) {
                        message.push('Link inválido');
                    }
                }
                else if(error.code === 209) {
                    // message.push('Sessão do usuário expirada');
                    
                    return redirect(LOGIN_PATH);
                }
            }
        }

        if (message.length <= 0) {
            message = [DEFAULT_ERROR_MESSAGE];
        }
    
        return {
            message: `${message.join('; ')}.`
        };
    }
  };